{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Välj en artikel",
  "tableResizer": "Storleksändrare",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
